module.exports = __webpack_public_path__ + "static/media/ios-walk.9dc33df5.svg";